export const getTranslationFromLocales = (prefix: string, locales: { [key: string]: string }) => (id: string, params?: { [key: string]: string | number }) => {
	const localeText = locales[`${prefix}.${id}`];

	if (params == null) {
		return localeText;
	} else {
		return Object.keys(params)
			.reduce(
				(result: string, key: string) => result.replace(new RegExp(`\{\{${key}\}\}`, 'g'), String(params[key])),
				localeText,
			);
	}
};
